/**
 * Visa expiration as a question rules answer: the month and year questions make up one 'YYYY-MM'
 * value, in the format the City / Visa rules compare chronologically on the server.
 *
 * @param {string|number|null|undefined} month
 * @param {string|number|null|undefined} year
 * @returns {string|null}
 */
export function formatVisaExpiration(month, year) {
    if (!month || !year) {
        return null;
    }

    return `${year}-${String(month).padStart(2, '0')}`;
}

/**
 * The answers to City, Visa Type and Visa Expiration, keyed the way the question rules expect.
 * Each landing flow reads the raw values from its own fields and passes them in.
 *
 * @param {{city?: string|null, visaType?: string|null, visaMonth?: string|null, visaYear?: string|null}} values
 * @returns {Object<string, string>}
 */
export function collectOnshoreFieldAnswers({ city, visaType, visaMonth, visaYear }) {
    const answers = {};

    if (city) {
        answers.city = city;
    }
    if (visaType) {
        answers.visa_type = visaType;
    }

    const visaExpiration = formatVisaExpiration(visaMonth, visaYear);
    if (visaExpiration) {
        answers.visa_expiration = visaExpiration;
    }

    return answers;
}
